/**
 * Parallax voor de blokken met .dbb-parallax: het beeld schuift trager dan de pagina.
 *
 * Geen background-attachment: fixed, want dat brak samen met de overflow-clip op de
 * body (witte marges bij brede viewports). In plaats daarvan verschuiven we een laag
 * die 20% hoger is dan de sectie, zodat er nooit een rand zichtbaar wordt.
 */
document.addEventListener("DOMContentLoaded", () => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const secties = Array.from(document.querySelectorAll(".dbb-parallax"))
    .map((sectie) => ({ sectie, beeld: sectie.querySelector(".dbb-parallax__img") }))
    .filter((x) => x.beeld);

  if (!secties.length) return;

  // hoeveel van de extra 20% we benutten; hoger = sterker effect
  const sterkte = 0.18;
  let ingepland = false;

  const teken = () => {
    ingepland = false;
    const vh = window.innerHeight;

    secties.forEach(({ sectie, beeld }) => {
      const r = sectie.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;   // buiten beeld, niets te doen
      const voortgang = (vh - r.top) / (vh + r.height);        // 0 onderaan, 1 bovenaan
      const verschuiving = (voortgang - 0.5) * r.height * sterkte;
      beeld.style.transform = `translate3d(0, ${verschuiving.toFixed(1)}px, 0)`;
    });
  };

  const plan = () => {
    if (ingepland) return;
    ingepland = true;
    requestAnimationFrame(teken);
  };

  window.addEventListener("scroll", plan, { passive: true });
  window.addEventListener("resize", plan);
  teken();
});
